import React from 'react';
import { OrderStatus, STATUS_COLORS } from '../../types/order';

interface StatusChipProps {
  status: OrderStatus;
  className?: string;
}

const StatusChip: React.FC<StatusChipProps> = ({ status, className = '' }) => {
  const colorMap: Record<string, string> = {
    gray: 'bg-gray-100 text-gray-800 border-gray-200',
    blue: 'bg-blue-100 text-blue-800 border-blue-200',
    purple: 'bg-purple-100 text-purple-800 border-purple-200',
    teal: 'bg-teal-100 text-teal-800 border-teal-200',
    green: 'bg-green-100 text-green-800 border-green-200',
    amber: 'bg-amber-100 text-amber-800 border-amber-200',
    red: 'bg-red-100 text-red-800 border-red-200',
  };
  
  const color = STATUS_COLORS[status] || 'gray';
  const colorClasses = colorMap[color] || colorMap.gray;
  
  const statusLabels: Record<OrderStatus, string> = {
    CREATED: 'Created',
    IN_PROGRESS: 'In Progress',
    PACKED: 'Packed',
    READY: 'Ready',
    COMPLETED: 'Completed',
    ON_HOLD: 'On Hold',
    CANCELLED: 'Cancelled',
  };
  
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${colorClasses} ${className}`}
    >
      {statusLabels[status]}
    </span>
  );
};

export default StatusChip;

